import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';

const ChannelConnectionSerializer = ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
  {
    isEmbeddedRecordsMixinCompatible: true,

    attrs: {
      channelLinks: {
        embedded: 'always',
      },
    },
  },
);

export default ChannelConnectionSerializer;

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'channel-connection': typeof ChannelConnectionSerializer;
  }
}
